import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.remote-app-access.edit', {
        url: '/:remoteAppId/edit',
        views: {
            '@company.manage-application': 'companyManageApplicationRemoteAppEdit',
        },
        resolve: {
            remoteApp,
            remoteAppId,
            groupsModel,
        }
    });
}

/** @ngInject */
function groupsModel(groups,remoteApp) {
	groupsModel= groups;
	groupsModel.map((group) => {group.isSelected=remoteApp.groups.findIndex(record => record.id===group.id) != -1;
	})
	return groupsModel;
}
/** @ngInject */
function remoteApp(remoteAppId, remoteApps) {
    return remoteApps.find((remoteApp) => remoteApp.sraRemoteApp.id === remoteAppId);
}

/** @ngInject */
function remoteAppId($stateParams) {
    return $stateParams.remoteAppId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/edit/edit-remote-app.state.js